module.exports = __webpack_public_path__ + "static/offer-m-2-64b2527ac81333980388caf6de6eb9c0.jpg";